import { css, Interpolation, Theme } from '@emotion/react'

export const container: Interpolation<Theme> = css`
  position: relative;
  width: 100%;
  height: 100%;
`

export const tableWrapper: Interpolation<Theme> = (theme) => css`
  .table-row .actions {
    box-sizing: border-box;
    height: 24px;
    display: flex;
    gap: 12px;
    align-items: end;
    transition: all ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut};
    overflow: hidden;
  }

  .table-row:not(:hover) .actions {
    height: 0;
  }
`

export const titleWrapper: Interpolation<Theme> = css`
  display: flex;
  flex-direction: column;
`

export const headerWrapper: Interpolation<Theme> = (theme) => css`
  justify-content: space-between;

  margin-top: ${theme.spacing(2)};
`

export const toolbarWrapper = (theme: Theme) => css`
  position: absolute;
  top: 0;
  right: 0;

  display: flex;
  flex-direction: column;

  transform: translateY(calc(-100% - ${theme.spacing(2)}));

  ${theme.breakpoints.down(620)} {
    position: relative;
    transform: none;
    margin: ${theme.spacing(2, 0)};

    div {
      width: 100%;
    }
  }
`

export const paginationTake: Interpolation<Theme> = (theme) => css`
  margin-bottom: ${theme.spacing(2)};
`

export const action: Interpolation<Theme> = css`
  height: 18px;
  padding: 0;
  min-width: 0;

  &.MuiButtonBase-root:hover {
    background: none;
  }
`

export const filtersWrapper: Interpolation<Theme> = (theme) => css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(2)};
  flex-wrap: wrap;
`
